// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Rt-z","tooltipWrapper":"St-z","icon":"Tt-z","tooltip":"Ut-z","content":"Vt-z"};